"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genAjaxServiceGatewayConfig = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _webOp = require("./webOp");
var _excluded = ["timeout", "params"];
/**
 * Represents a fully processed ajax service gateway response. Right now
 * there is no standardized pattern for ajax service gateway responses so
 * it is currently the same as a WebopResponse.
 */

var encodeQueryParams = function encodeQueryParams(params) {
  if (params === undefined) {
    return undefined;
  }
  return Object.keys(params).reduce(function (acc, cur) {
    var value = params[cur];
    return "".concat(acc).concat(acc.length ? "&" : "").concat(encodeURIComponent(cur), "=").concat(encodeURIComponent(value));
  }, "");
};

/**
 * Generates an axios request config that's ready to send for an ajax gateway request
 * @param config configuration object for the request
 */
var genAjaxServiceGatewayConfig = function genAjaxServiceGatewayConfig(config) {
  var timeout = config.timeout,
    params = config.params,
    request = (0, _objectWithoutProperties2.default)(config, _excluded);
  var encodedQueryParams = encodeQueryParams(params);
  var conf = (0, _webOp.genWebopRequestConfig)({
    formAction: "SendGatewayRequest",
    timeout: timeout
  }, {
    gatewayRequest: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, request), {}, {
      encodedQueryParams: encodedQueryParams
    })
  });
  return conf;
};
exports.genAjaxServiceGatewayConfig = genAjaxServiceGatewayConfig;
//# sourceMappingURL=ajaxServiceGateway.js.map